import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=3d0fa990"
import script from "./ModalHeader.vue?vue&type=script&lang=ts"
export * from "./ModalHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0fa990')) {
      api.createRecord('3d0fa990', component.options)
    } else {
      api.reload('3d0fa990', component.options)
    }
    module.hot.accept("./ModalHeader.vue?vue&type=template&id=3d0fa990", function () {
      api.rerender('3d0fa990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ModalHeader.vue"
export default component.exports